export default class SizeConfiguration {
    constructor(rawData = {}) {
      this.id = rawData.id;
      this.imageSize = rawData.imageSize;
      this.fileSize = rawData.fileSize
    }
  }
  